import type { ReaderBlock, ReaderContent } from '@/types/reader'

export type SavedReaderSentence = {
  id: string
  text: string
  translation?: string
  sourceTitle: string
  sourceType: ReaderContent['sourceType']
  contentId: string
  blockId: string
  savedAt: string
}

export const SAVED_SENTENCES_CHANGED_EVENT =
  'miaozi:saved-reader-sentences-changed'

const SAVED_SENTENCES_KEY = 'miaozi:saved-reader-sentences'

export function readSavedSentences(): SavedReaderSentence[] {
  if (typeof window === 'undefined') return []
  try {
    const raw = window.localStorage.getItem(SAVED_SENTENCES_KEY)
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

export function saveReaderSentence(
  content: ReaderContent,
  block: ReaderBlock,
  text: string
) {
  if (typeof window === 'undefined') return false
  const saved = readSavedSentences()
  const id = `${content.id}:${block.id}`
  const next: SavedReaderSentence = {
    id,
    text,
    translation: block.translation,
    sourceTitle: content.title,
    sourceType: content.sourceType,
    contentId: content.id,
    blockId: block.id,
    savedAt: new Date().toISOString()
  }

  const existingIndex = saved.findIndex((item) => item.id === id)
  if (existingIndex >= 0) {
    saved[existingIndex] = next
  } else {
    saved.unshift(next)
  }

  window.localStorage.setItem(
    SAVED_SENTENCES_KEY,
    JSON.stringify(saved.slice(0, 500))
  )
  window.dispatchEvent(new Event(SAVED_SENTENCES_CHANGED_EVENT))
  return existingIndex < 0
}
